import { createFileRoute } from "@tanstack/react-router"

import PriceChangeHistoryContainer from "@/screens/Pricing/containers/PricingChangeHistoryContainer"

export const Route = createFileRoute("/app/pricing/_layout/history-price-change")({
  component: PriceChangeHistoryContainer,
})
